import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DEMO_VENUES, useAuth } from '@/lib/auth';
import { useLiveStatus } from '@/lib/live-status';
import { onVenueSwitchPrepare, venueSwitchTargetPath } from '@/lib/venue-switch';
import { VenueSwitchOverlay } from '@/components/VenueSwitchOverlay';

/** Navigates away from venue-specific routes and shows the switch overlay. */
export function VenueSwitchBridge() {
  const { switchingVenue, apiKey } = useAuth();
  const navigate = useNavigate();
  const { setConnected } = useLiveStatus();
  const venueLabel = DEMO_VENUES.find((v) => v.key === apiKey)?.label ?? '';

  useEffect(() => {
    return onVenueSwitchPrepare(() => {
      setConnected(false);
      const target = venueSwitchTargetPath(window.location.pathname, window.location.search);
      if (target) navigate(target, { replace: true });
    });
  }, [navigate, setConnected]);

  return <VenueSwitchOverlay active={switchingVenue} venueLabel={venueLabel} />;
}
